import { AppState } from 'src';
import { connect, Dispatch } from 'react-redux';
import { PropertyInfoComponent, PropertyInfoComponentProperties } from './property-info.component';
import { ContractViewModel } from '@models/Contract';
import { ModalProps } from '@common/components/modal';
import { toggleModal, checkZipCode } from '@common/components/common.actions';
import { AddressViewModel, OptionsViewModel } from '@models/common.models';
import { registerAddressVerifier } from '@common/components/common.actions';
import FormNames from '@constants/FormNames.enum';
import {
  getContactInitiators,
  getContactMediums,
  getContactTypes,
  getPropertyTypes,
  getPropertySaleTypes,
  savePropertyInfo,
  setOrderType,
  clearPriceAdjustmentFromVM
} from 'src/contract/contract.actions';
import { setIsStoringPropertyInfo } from '../order-edit/order-edit.actions';
import { resetPriceAdjustments } from '../coverage'; // removed clearCoverageStore
import { clearQuotePriceAdjustments } from 'src/quote/quote.actions';
/*
This is the container for the component.
This "connects" the redux and react layers by translating the state of the page into props for the component.
It also wires up the actions so the component can emit them.
*/
export interface PropertyInfoProperties {
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly next?: Function;
  readonly failCallback?: Function;
  readonly currentStep: number;
  readonly isOrderEdit?: boolean;
}
// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState, ownProps: PropertyInfoProperties): Partial<PropertyInfoComponentProperties> {
  return {
    message: state.contract.message,
    currentStep: ownProps.currentStep,
    contractVM: state.contract.contractVM,
    verifiableAddress: state.propertyInfoForm.propertyAddress,
    contactInitiators: state.contract.contactInitiators,
    contactMediums: state.contract.contactMediums,
    contactTypes: state.contract.contactTypes,
    propertyTypes: state.contract.propertyTypes,
    propertySaleTypes: state.contract.propertySaleTypes,
    buttonRef: ownProps.buttonRef,
    isOrderEdit: ownProps.isOrderEdit,
    isVerifying: state.common.isVerifying,
    isLoadingResale: state.contract.isLoadingResale,
    isOpenContract: state.contract.isOpenContract
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: PropertyInfoProperties
): Partial<PropertyInfoComponentProperties> {
  return {
    getContactInitiators: () => {
      dispatch(getContactInitiators());
    },
    getContactMediums: () => {
      dispatch(getContactMediums());
    },
    getContactTypes: () => {
      dispatch(getContactTypes());
    },
    getPropertyTypes: () => {
      dispatch(getPropertyTypes());
    },
    getPropertySaleTypes: () => {
      dispatch(getPropertySaleTypes());
    },
    setOrderType: (type: number) => {
      // Set DTC or R/E value for different flows
      dispatch(setOrderType(type));
    },
    onSaveClick: async (model: ContractViewModel) => {
      var isCovered = await dispatch(checkZipCode(+model.propertyAddress.zip));
      if (isCovered) {
        await dispatch(savePropertyInfo(model));
        if (ownProps.next) {
          ownProps.next();
        }
      } else if (ownProps.failCallback) {
        ownProps.failCallback();
      }
      await dispatch(setIsStoringPropertyInfo(false));
    },
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    updateCoverages: async (
      model: ContractViewModel,
      zipCode?: string,
      propertySaleType?: OptionsViewModel,
      propertyType?: OptionsViewModel,
      yearBuilt?: string
    ) => {
      var isCovered = await dispatch(checkZipCode(+model.propertyAddress.zip));
      if (isCovered) {
        var contractVM = {
          ...model,
          propertyAddress: {
            ...model.propertyAddress,
            zip: zipCode || model.propertyAddress.zip
          } as AddressViewModel,
          propertySaleType: propertySaleType || model.propertySaleType,
          propertyType: propertyType || model.propertyType,
          yearBuilt: yearBuilt || model.yearBuilt
        } as ContractViewModel;

        await dispatch(savePropertyInfo(contractVM));
        if (ownProps.next) {
          ownProps.next();
        }
      } else if (ownProps.failCallback) {
        ownProps.failCallback();
      }
    },
    clearPriceAdjustments: async () => {
      await dispatch(resetPriceAdjustments());
      await dispatch(clearQuotePriceAdjustments());
      await dispatch(clearPriceAdjustmentFromVM());
    },
    registerAddressVerifier: async (shouldCheckDuplicates: boolean) => {
      try {
        var result = await dispatch(
          registerAddressVerifier(
            FormNames.PropertyInfoForm,
            'propertyAddress',
            (s: any, a: AddressViewModel) => {
              return {
                ...s,
                propertyAddress: {
                  ...a
                }
              };
            },
            shouldCheckDuplicates
          )
        );
        return result;
      } catch (e) {
        // do nothin
        //  return null;
        return;
      }
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const PropertyInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyInfoComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/property-info/property-info.container.ts